import { useMemo, type ReactNode } from "react";
import { LockedAutocomplete } from "@/components/LockedAutocomplete";
import type { AutocompleteOption } from "@/components/LockedAutocomplete";
import { filterMaterialUnits, normalizeMaterialUnit } from "@/lib/materialUnits";

interface UnitAutocompleteFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  label?: ReactNode;
  hint?: ReactNode;
}

export function UnitAutocompleteField({
  value,
  onChange,
  disabled,
  placeholder = "Einheit",
  className,
  label,
  hint,
}: UnitAutocompleteFieldProps) {
  const unitValue = useMemo((): AutocompleteOption<string> | null => {
    const raw = value.trim();
    if (!raw) return null;
    const normalized = normalizeMaterialUnit(raw) || raw;
    return { key: normalized, label: normalized, value: normalized };
  }, [value]);

  return (
    <div className={className ?? "[&_.eh-input]:text-sm"}>
      <LockedAutocomplete<string>
        label={label}
        hint={hint}
        placeholder={placeholder}
        value={unitValue}
        disabled={disabled}
        minChars={0}
        loadOptions={async (q) =>
          filterMaterialUnits(q).map((u) => ({ key: u, label: u, value: u }))
        }
        onChange={(opt) => onChange(opt?.value ?? "")}
      />
    </div>
  );
}
